import React from "react";
import { useState } from "react";
import { generaTablaAmortizacion } from "../functions/generaTablaAmortizacion";
import { generaOperaciones } from "functions/generaOperaciones";
import Api from "../functions/Api";
import { pdf } from "@react-pdf/renderer";
import { ValidationResponse } from "../functions/validation";
import QRCode from "qrcode";
import PurchaseTicket from "components/Contract/Purchaseticket";

const usePayment = ({
  handleMuestraSnack,
  setBotonSigDisabled,
  setBackDisabled
}) => {
  const [paymentMade, setPaymentMade] = useState(false);
  const [infopayContract, setInfoPayContract] = useState();
  const [tblPaymenth, setTblPaymenth] = useState();
  const [ejecutaapi] = Api();
  const usuario = localStorage.getItem("user");
  const [infoContract, setInfoContract] = useState({});
  const [infoPaymenth, setInfoPaymenth] = useState();
  const [load, setLoad] = useState(false);

  const handlepaymenth = (values, infoptbl) => {
    setLoad(true);
    const { MontoPago, MetodoPago, fechapago, consecutivo } = values;

    // Fix #5: validar que exista contrato cargado
    if (!infoptbl || !infoptbl.ID_AMORTIZACION) {
      handleMuestraSnack("Primero busque y seleccione un contrato", "warning");
      setLoad(false);
      return;
    }

    // Fix #8: validar monto
    if (!MontoPago || parseFloat(MontoPago) <= 0) {
      handleMuestraSnack("El monto de pago debe ser mayor a 0", "warning");
      setLoad(false);
      return;
    }

    // Fix #9: validar método de pago
    if (!MetodoPago) {
      handleMuestraSnack("Seleccione un método de pago", "warning");
      setLoad(false);
      return;
    }

    const { ID_AMORTIZACION, JTBL_AMORTIZACION, pidLote } = infoptbl;

    // Primero validar que el cajero tenga caja abierta
    const userId = JSON.parse(usuario).userId;
    const validaBody = JSON.stringify({ idCajero: userId });

    ejecutaapi("ValidaCajaAbierta", validaBody).then(validaData => {
      let { result: validaResult, error: validaError } = ValidationResponse(validaData);

      if (validaError !== "") {
        handleMuestraSnack(validaError, "error");
        setLoad(false);
        return;
      }

      if (validaResult[0] && validaResult[0].error === 1) {
        const msg = validaResult[0].vencida === 1
          ? validaResult[0].msg + " Ve a Control de Caja para cerrarla y abrir una nueva."
          : validaResult[0].msg;
        handleMuestraSnack(msg, "error");
        setLoad(false);
        return;
      }

      // Caja abierta, proceder con el pago
      const { operaciones, updatesTblAmort } = generaOperaciones(
        Number(MontoPago).toFixed(2),
        typeof JTBL_AMORTIZACION === "string" ? JSON.parse(JTBL_AMORTIZACION) : JTBL_AMORTIZACION,
        MetodoPago,
        fechapago,
        consecutivo
      );

      // Obtener datos descriptivos del usuario logueado
      const userData = JSON.parse(usuario);

      const datajson = {
        idCajero: userId,
        idLote: pidLote,
        MontoPago: MontoPago,
        idTblAmortizacion: ID_AMORTIZACION,
        idmetodopago: MetodoPago,
        operaciones,
        updatesTblAmort,
        // Datos descriptivos para el recibo
        cajeroNombre: userData.nombre || userData.email || "Cajero #" + userId,
        clienteNombre: infoptbl.clienteNombre || "",
        numContrato: infoptbl.ID_CONTRATO || "",
        desarrollo: infoptbl.desarrollo || "",
        loteDesc: infoptbl.loteDesc || "Lote #" + pidLote
      };
      console.log(datajson);
      ejecutaapi("generaMovimientos", JSON.stringify(datajson)).then(data => {
        let { error } = ValidationResponse(data);

        if (error !== "") {
          handleMuestraSnack(error, "error");
        } else {
          setTblPaymenth(updatesTblAmort);
          setInfoPaymenth(datajson);
          setPaymentMade(true);
          handleMuestraSnack("Se realizo el pago correctamente", "success");
          // Refrescar info del contrato para actualizar estatus (P→C después de enganche)
          setTimeout(() => {
            if (infopayContract && infopayContract.ID_CONTRATO) {
              handleGetContractInfo(0, infopayContract.ID_CONTRATO);
            }
          }, 800);
          // Auto-generar recibo PDF
          setTimeout(async () => {
            try {
              const url = await generateReciboPdfInternal(datajson);
              if (url) window.open(url, "_blank");
            } catch (e) { console.error("Error generando recibo:", e); }
          }, 300);
        }
        setLoad(false);
      }).catch(() => {
        handleMuestraSnack("Error al procesar el pago", "error");
        setLoad(false);
      });
    }).catch(() => {
      handleMuestraSnack("Error al validar caja abierta", "error");
      setLoad(false);
    });
  };

  const handleGetContractInfo = async (opt = 0, pIdContrato) => {
    if (!pIdContrato) {
      handleMuestraSnack && handleMuestraSnack("Ingrese un numero de contrato", "warning");
      return;
    }
    let body = JSON.stringify({
      pIdContrato,
      usuario: JSON.parse(usuario).email
    });

    try {
      const data = await ejecutaapi("obtieneinfopagocontrato", body);
      let { error, result } = ValidationResponse(data);
      if (error !== "") {
        handleMuestraSnack(error, "error");
        return;
      }
      if (!result || result.length === 0) {
        handleMuestraSnack(
          "No se encontro contrato con ese numero o no se ha confirmado el contrato",
          "warning"
        );
        return;
      }
      const { JTBL_AMORTIZACION, pidLote, estatus_lote, cliente_nombre, desarrollo, manzana, num_lote } = result[0];
      const loteDescriptivo = manzana && num_lote ? (manzana + " - Lote " + num_lote) : "Lote #" + pidLote;
      const extraInfo = { clienteNombre: cliente_nombre || "", desarrollo: desarrollo || "", loteDesc: loteDescriptivo };

      if (pidLote == null) {
        // Contrato no encontrado o sin lote asociado
        setInfoPayContract(null);
        setTblPaymenth(null);
        handleMuestraSnack && handleMuestraSnack("No se encontró contrato con ese número", "warning");
      } else if (estatus_lote === 'P') {
        // Contrato pendiente — mostrar datos para cobrar enganche
        setInfoPayContract({ ...result[0], ...extraInfo, pendiente: true, liquidado: false, ID_CONTRATO: pIdContrato });
        const tbl = typeof JTBL_AMORTIZACION === "string" ? JSON.parse(JTBL_AMORTIZACION) : JTBL_AMORTIZACION;
        setTblPaymenth(Array.isArray(tbl) ? tbl : [tbl]);
        handleMuestraSnack && handleMuestraSnack("Se muestra la informacion del contrato", "success");
      } else if (estatus_lote === 'L') {
        // Contrato liquidado
        setInfoPayContract({ ...result[0], ...extraInfo, liquidado: true, pendiente: false, ID_CONTRATO: pIdContrato });
        const tbl = typeof JTBL_AMORTIZACION === "string" ? JSON.parse(JTBL_AMORTIZACION) : JTBL_AMORTIZACION;
        setTblPaymenth(Array.isArray(tbl) ? tbl : [tbl]);
        handleMuestraSnack && handleMuestraSnack("Contrato liquidado — solo consulta", "info");
      } else {
        // Contrato activo (estatus C)
        setInfoPayContract({ ...result[0], ...extraInfo, liquidado: false, pendiente: false, ID_CONTRATO: pIdContrato });
        const tbl = typeof JTBL_AMORTIZACION === "string" ? JSON.parse(JTBL_AMORTIZACION) : JTBL_AMORTIZACION;
        setTblPaymenth(Array.isArray(tbl) ? tbl : [tbl]);
        handleMuestraSnack &&
          handleMuestraSnack("Se muestra la informacion del contrato", "success");
      }
    } catch (err) {
      console.error("Error en handleGetContractInfo:", err);
      handleMuestraSnack("Error al consultar contrato. Verifique que el contrato exista y este confirmado.", "error");
    }
  };

  const generateReciboPdfInternal = async (data) => {
    const generateQRImage = async text => {
      try { return await QRCode.toDataURL(text); } catch (err) { console.error(err); }
    };
    const ref = data.operaciones && data.operaciones.length > 0 ? data.operaciones[0].referencia : "PAGO";
    const qrImage = await generateQRImage(ref);
    const Contract = () => <PurchaseTicket purchaseData={data} qrImage={qrImage} />;
    const pdfBlob = await pdf(<Contract />).toBlob();
    return URL.createObjectURL(pdfBlob);
  };

  const generateReciboPdf = async () => {
    if (!infoPaymenth) return null;
    return generateReciboPdfInternal(infoPaymenth);
  };

  const handleGenerateContract = async (values, infoclientes, infolotes) => {
    let { ID_CLIENTE } = infoclientes;
    let {
      costo,
      enganche,
      mensualidades,
      fechapago,
      intereses,
      tipocontrato,
      testigo1,
      testigo2,
      tipopago
    } = values;

    let fechapagoparseado = new Date(fechapago);
    var dia = fechapagoparseado
      .getDate()
      .toString()
      .padStart(2, "0");
    var mes = (fechapagoparseado.getMonth() + 1)
      .toString()
      .padStart(2, "0");
    var anio = fechapagoparseado.getFullYear().toString();
    fechapagoparseado = dia + "-" + mes + "-" + anio;
    let montoPago = (costo - enganche) / mensualidades;

    let lotes = [];
    //let totalSuperficie = 0;

    /*infolotes.forEach(lote => {
      lotes.push(lote.ID_LOTE);
      totalSuperficie += lote.SUPERFICIE;
    });*/
    lotes.push(infolotes.ID_LOTE);
    //lotes.push(infolotes.SUPERFICIE);

    let jsonenvio = JSON.stringify({
      ptipoContrato: tipocontrato === "credito" ? 2 : 1,
      ptipoPago: 1,
      pcostoTotal: costo,
      psuperficieTotal: infolotes.SUPERFICIE,
      pmensualidades: mensualidades,
      pmontoEnganche: enganche,
      pmontoMensualidad: montoPago,
      ptestigo1: testigo1,
      ptestigo2: testigo2,
      pidCliente: ID_CLIENTE,
      pidLote: lotes,
      pidCajero: JSON.parse(usuario).userId,
      pmetodoPago: 1,
      pfechaPagos: fechapagoparseado,
      pinteres: intereses,
      usuario: JSON.parse(usuario).email,
      pTblAmortizacion:
        tipocontrato === "credito"
          ? generaTablaAmortizacion(
              costo,
              enganche,
              mensualidades,
              fechapago,
              0
            )
          : [
              {
                id: 0,
                pago: 0,
                estatus: "P",
                interes: 0,
                fechapago: "",
                moratorio: 0,
                anticipado: 0,
                fechaapagar: fechapagoparseado,
                montoapagar: costo
              }
            ]
    });
    try {
      const data = await ejecutaapi("insertaContrato", jsonenvio);
      let { error, result } = ValidationResponse(data);
      if (error !== "") {
        handleMuestraSnack(error, "error");
      } else {
        handleMuestraSnack("Contrato generado. El cajero debe cobrar el enganche desde Cobranza para activarlo.", "success");
        setBackDisabled(true);
        setBotonSigDisabled(false);
        setPaymentMade(true);
        let infoContract = {
          contrato: result[0],
          infoContrato: JSON.parse(jsonenvio)
        };
        setInfoContract(infoContract);
      }
    } catch (error) {
      handleMuestraSnack("Error al ejecutar API:", "error");
    }
  };
  return {
    paymentMade,
    handleGenerateContract,
    handleGetContractInfo,
    infopayContract,
    handlepaymenth,
    tblPaymenth,
    infoContract,
    generateReciboPdf,
    load
  };
};

export default usePayment;
